/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- TRIVIA ANALYTICS - TOP POLL AND QUIZ REPORT : STYLES --------------- ++++++++++ */
export default {
    toppollandquizreport: {
    }
};
